import { createSlice } from "@reduxjs/toolkit";

import {
    getConnectionReportsAsync,
    getConnectionSourceMappingAsync,
} from "./leadReports.asyncActions";
import { initialState } from "./leadReports.types";

export const leadReportsSlice = createSlice({
    name: "leadReports",
    initialState,
    reducers: {
        clearConnectionReport: (state) => {
            state.connectionReport = null;
            return state;
        },
        clearSourceMapping: (state) => {
            state.sourceMapping = null;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConnectionReportsAsync.pending, (state) => {
                state.isReportsLoading = true;
            })
            .addCase(getConnectionReportsAsync.fulfilled, (state, action) => {
                state.isReportsLoading = false;
                state.connectionReport = action.payload;
            })
            .addCase(getConnectionReportsAsync.rejected, (state, action) => {
                state.isReportsLoading = false;
            })
            .addCase(getConnectionSourceMappingAsync.pending, (state) => {
                state.isSourceMappingLoading = true;
            })
            .addCase(
                getConnectionSourceMappingAsync.fulfilled,
                (state, action) => {
                    state.isSourceMappingLoading = false;
                    state.sourceMapping = action.payload;
                },
            )
            .addCase(getConnectionSourceMappingAsync.rejected, (state) => {
                state.isSourceMappingLoading = false;
            });
    },
});
export default leadReportsSlice.reducer;
export const { clearConnectionReport, clearSourceMapping } =
    leadReportsSlice.actions;
